import * as Mithril from 'mithril';
import Component from 'flarum/common/Component';
import sortWidgets from '../../common/utils/sortWidgets';

export default class WelcomeBox extends Component {
  view(): Mithril.Children {
    if (app.current.data.routeName !== 'index') return null;

    const widgets = app.widgets.get('WelcomeBox') || [];
    
    // 直接返回数组（需父组件支持）
    return sortWidgets(widgets).map((widget) => (
      widget.component.component({
        state: widget.state,
        key: widget.id,
      })
    ));
  }
}